export default __webpack_public_path__ + "images/45_1_image.jpg";